
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
@Component
export default class NewSidebarItem extends Vue {
  @Prop(Object) item: any;
  @Prop({ default: false }) mini: boolean;
  @Prop({ default: false }) selected: boolean;
  @Prop(Boolean) isNotification: boolean;
  @Prop(Boolean) isMessageNotification: boolean;
  @Prop({ default: true }) isImage: boolean;
  @Prop({ default: false }) isFixed: boolean;
  @Prop({ default: "px-3" }) paddingButton: string;
  @Prop({ default: false }) right: boolean;
  @State((state) => state.community.notificationNewCommunity)
  notificationNewCommunity: any;
  @State((state) => state.post.currentTransmission)
  currentTransmission: any;

  // Intervalo para atualizar o contador
  countdownInterval: any = null;
  // Texto do contador para exibição
  displayCountdownText = "";
  // Flag para indicar se a transmissão está ao vivo
  showLiveIndicator = false;

  // Inicializar o intervalo de contagem regressiva quando o componente for montado
  mounted() {
    this.startCountdownInterval();
  }

  // Limpar o intervalo quando o componente for destruído
  beforeDestroy() {
    this.clearCountdownInterval();
  }

  // Observar mudanças na propriedade currentTransmission
  @Watch("currentTransmission", { deep: true })
  onCurrentTransmissionChanged(newVal: any, oldVal: any) {
    // Verificar se realmente mudou para evitar loops
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      // Reiniciar o intervalo quando a transmissão atual mudar
      this.clearCountdownInterval();
      this.startCountdownInterval();
    }
  }

  get colorText(): string {
    const colorFixed = this.right
      ? "black--text"
      : this.isFixed
      ? this.$vuetify.breakpoint.mdAndDown
        ? "white--text"
        : "gray90--text"
      : this.$vuetify.breakpoint.mdAndDown
      ? "white--text"
      : "gray70--text";
    const padding = this.isImage ? "pl-3" : "pl-7";
    const selected = this.$vuetify.breakpoint.mdAndDown
      ? "pink--text"
      : "purple100--text";
    return this.selected
      ? `${selected} font-weight-bold ${padding}`
      : `${colorFixed} font-weight-bold ${padding}`;
  }
  get classButton(): string {
    return this.mini ? "button-sidebar-item" : "";
  }
  // Verificar se a transmissão está ao vivo
  get isTransmissionLive(): boolean {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return false;
    }

    // A transmissão está ao vivo se já começou mas ainda não terminou
    return this.hasTransmissionStarted && !this.hasTransmissionEnded;
  }

  // Verifica se a transmissão já começou
  get hasTransmissionStarted(): boolean {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return false;
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();

    return now > startTime; // Retorna true se a transmissão já começou
  }

  // Verifica se a transmissão já terminou
  get hasTransmissionEnded(): boolean {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return false;
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();
    const endTime = startTime + this.currentTransmission.duration * 60 * 1000;

    return now > endTime; // Retorna true se a transmissão já terminou
  }

  get customIcon(): any {
    return this.isFixed
      ? this.item.imageHover
      : this.$vuetify.breakpoint.mdAndDown
      ? this.selected
        ? this.item.imageSelectedMini
        : this.item.imageUnselected
      : this.selected
      ? this.mini
        ? this.item.imageSelectedMini
        : this.item.imageSelected
      : this.item.imageUnselected;
  }
  get customIconColor(): string {
    return this.isFixed
      ? "black"
      : this.$vuetify.breakpoint.mdAndDown
      ? this.selected
        ? "pink"
        : "white"
      : this.selected
      ? this.mini
        ? "white"
        : "purple100"
      : "gray70";
  }
  get hoverIconColor(): string {
    return this.mini
      ? "pink"
      : this.$vuetify.breakpoint.mdAndDown
      ? this.customIconColor
      : "black";
  }
  get iconCssVariables(): object {
    return {
      "--icon-hover-color": this.getColorValue(this.hoverIconColor),
    };
  }
  getColorValue(colorName: string): string {
    const colorMap: { [key: string]: string } = {
      black: "var(--v-black-base)",
      purple100: "var(--v-purple100-base)",
      gray70: "var(--v-gray70-base)",
      pink: "var(--v-pink-base)",
      white: "var(--v-white-base)",
    };
    return colorMap[colorName] || colorMap.gray70;
  }
  get countdownText(): string {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return "";
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();
    const endTime = startTime + this.currentTransmission.duration * 60 * 1000; // Duração em milissegundos

    // Verificar se a transmissão já terminou
    if (now > endTime) {
      return ""; // Transmissão encerrada
    }

    const timeRemaining = startTime - now;

    // Se a transmissão já começou (mas ainda não terminou)
    if (timeRemaining <= 0) {
      // Verificar se a transmissão está ao vivo
      if (this.isTransmissionLive) {
        return this.$t("transmission.transmissionLive").toString();
      }
      return "";
    } else {
      // A transmissão ainda não começou, calcular o tempo restante
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Formatar a saída com base no tempo restante
      if (days > 0) {
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
      } else {
        // Menos de 1 minuto para começar
        return `${seconds}s`;
      }
    }
  }

  // Método para iniciar o intervalo de contagem regressiva
  startCountdownInterval() {
    // Não iniciar o intervalo se não houver transmissão
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return;
    }

    // Limpar intervalo existente se houver
    if (this.countdownInterval) {
      this.clearCountdownInterval();
    }

    // Verificar o estado inicial da transmissão
    this.checkTransmissionStatus();

    // Atualizar a cada segundo
    this.countdownInterval = setInterval(() => {
      // Verificar se a transmissão ainda existe
      if (!this.currentTransmission || !this.currentTransmission.startTime) {
        this.clearCountdownInterval();
        return;
      }

      // Verificar o estado atual da transmissão
      this.checkTransmissionStatus();

      // Forçar a renderização para garantir que as mudanças sejam aplicadas
      this.$forceUpdate();

      // Se a transmissão terminou, limpar o intervalo
      if (this.hasTransmissionEnded) {
        this.clearCountdownInterval();
      }
    }, 1000);
  }

  // Método para limpar o intervalo de contagem regressiva
  clearCountdownInterval() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  // Método para verificar o status da transmissão e atualizar a interface
  checkTransmissionStatus() {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      this.displayCountdownText = "";
      this.showLiveIndicator = false;
      return;
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();
    const endTime = startTime + this.currentTransmission.duration * 60 * 1000;

    // Verificar se a transmissão já terminou
    if (now > endTime) {
      this.displayCountdownText = "";
      this.showLiveIndicator = false;
      return;
    }

    const timeRemaining = startTime - now;

    // Verificar se a transmissão está ao vivo
    if (timeRemaining <= 0) {
      // A transmissão já começou, mostrar o indicador de ao vivo
      this.showLiveIndicator = true;
      this.displayCountdownText = "";
    } else {
      // A transmissão ainda não começou, mostrar o contador
      this.showLiveIndicator = false;

      // Calcular o tempo restante
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Formatar a saída com base no tempo restante
      if (days > 0) {
        this.displayCountdownText = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else if (hours > 0) {
        this.displayCountdownText = `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        this.displayCountdownText = `${minutes}m ${seconds}s`;
      } else {
        // Menos de 1 minuto para começar
        this.displayCountdownText = `${seconds}s`;
      }
    }
  }
}
